import calendarIcon from 'assets/package-assets/calendar-64748b.svg';
import bronzeDiamondIcon from 'assets/package-assets/package-c84b31.svg';
import silverDiamondIcon from 'assets/package-assets/package-64748b.svg';
import goldDiamondIcon from 'assets/package-assets/package-eba33b.svg';
import savingIcon from 'assets/package-assets/saving-c84b31.svg';
import { IPackageProgramTier } from 'services/shop/types/package-program';
import { Check } from 'lucide-react';
import { formatCurrency } from 'utils/formatCurrency';
import { formatPackageSaveLabel, getPackageTierValidityMonths } from './package-tier-helpers';
import { PackageThemeKey } from 'features/cashier/services/package-theme';
import { TierCard } from './package-tier-card-styles';

const THEME_DIAMOND_ICON: Record<PackageThemeKey, string> = {
  bronze: bronzeDiamondIcon,
  silver: silverDiamondIcon,
  gold: goldDiamondIcon,
};

type Props = {
  tier: IPackageProgramTier;
  theme: PackageThemeKey;
  /** tier đã có trên ticket: thẻ tô màu, có dấu ✓, nút khoá */
  added?: boolean;
  onAddToTicket: () => void;
};

// Một tier (Bronze / Silver / Gold) của program: số buổi, giá gói, mức tiết kiệm, nút thêm vào ticket
const PackageTierCard = ({ tier, theme, added = false, onAddToTicket }: Props) => {
  const validityMonths = getPackageTierValidityMonths(tier);

  return (
    <TierCard themeKey={theme} $added={added}>
      <div className='tier-head'>
        <img className='tier-icon' src={THEME_DIAMOND_ICON[theme]} alt='' />
        <div>
          <p className='tier-name'>{tier.name}</p>
          <p className='tier-caption'>PACKAGE</p>
        </div>
        {added && (
          <span className='tier-added-check'>
            <Check size={20} strokeWidth={3} />
          </span>
        )}
      </div>
      <div className='tier-body'>
        <p className='tier-sessions'>{tier.quantity} Sessions</p>
        <div>
          <p className='tier-price-label'>Package Price</p>
          <p className='tier-price'>{formatCurrency(tier.packagePrice)}</p>
          <div className='tier-value-row'>
            <span>
              <span className='tier-original'>{formatCurrency(tier.originalPrice)}</span> value
            </span>
            <span className='tier-save'>{formatPackageSaveLabel(tier)}</span>
          </div>
        </div>
        <div className='tier-line tier-per-session'>
          <img src={savingIcon} alt='' />
          Only {formatCurrency(tier.pricePerSession)} / session
        </div>
        {validityMonths !== null && (
          <div className='tier-line'>
            <img src={calendarIcon} alt='' />
            Valid for {validityMonths} months
          </div>
        )}
        <button type='button' className='tier-add-button' disabled={added} onClick={onAddToTicket}>
          {added ? (
            <>
              <Check size={20} strokeWidth={3} />
              Added to Ticket
            </>
          ) : 'Add to Ticket'}
        </button>
      </div>
    </TierCard>
  );
};

export default PackageTierCard;
